const A = (t) => {
  if (/youtu\.?be/.test(t)) {
    const n = [
      /youtu\.be\/([^#&?]{11})/,
      /\?v=([^#&?]{11})/,
      /&v=([^#&?]{11})/,
      /embed\/([^#&?]{11})/,
      /\/v\/([^#&?]{11})/,
    ];
    for (let i = 0; i < n.length; ++i) if (n[i].test(t)) return n[i].exec(t)[1];
  }
  return /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/.test(t)
    ? /^.*(vimeo\.com\/)((channels\/[A-z]+\/)|(groups\/[A-z]+\/videos\/))?([0-9]+)/.exec(t)[5]
    : null;
};
function T(t) {
  const n = {TRIGGER_PLAY_PAUSE_SELECTOR: '.js-play-pause-video'},
    i = {PLAYING_CLASS: 'is-playing', PAUSE_CLASS: 'is-paused'};
  let e;
  const a = {play: !1, pause: !0},
    u = JSON.parse(t.getAttribute('data-settings')),
    o = {videoId: u.videoType !== 'mp4' && A(u.videoUrl), ...u},
    p = {type: o.videoType, element: t},
    v = t.querySelector(n.TRIGGER_PLAY_PAUSE_SELECTOR),
    d = () => {
      o.videoType !== 'youtube' ? e.play() : e.playVideo(),
        t.classList.add(i.PLAYING_CLASS),
        t.classList.remove(i.PAUSE_CLASS),
        (a.play = !0),
        (a.pause = !1),
        document.dispatchEvent(new window.CustomEvent('videoManagement:play', {detail: {player: e, ...p}}));
    },
    c = () => {
      o.videoType !== 'youtube' ? e.pause() : e.pauseVideo(),
        (a.play = !1),
        (a.pause = !0),
        t.classList.remove(i.PLAYING_CLASS),
        t.classList.add(i.PAUSE_CLASS);
    },
    m = () =>
      new Promise((s, r) => {
        let y = '';
        if (!window.YT || !window.Vimeo) {
          !window.YT && o.videoType === 'youtube'
            ? (y = '//www.youtube.com/iframe_api')
            : !window.Vimeo && o.videoType === 'vimeo' && (y = '//player.vimeo.com/api/player.js');
          const l = document.createElement('script');
          document.body.appendChild(l), (l.onload = s), (l.onerror = r), (l.async = !0), (l.src = y);
        } else s();
      }),
    w = () => {
      const s = t.querySelector('.js-video'),
        r = setInterval(() => {
          o.videoType === 'youtube'
            ? window.YT &&
              ((e = new window.YT.Player(s, {
                videoId: o.videoId,
                playerVars: {
                  showinfo: 0,
                  controls: 0,
                  fs: 0,
                  rel: 0,
                  height: '100%',
                  width: '100%',
                  iv_load_policy: 3,
                  html5: 1,
                  loop: 1,
                  playsinline: 1,
                  modestbranding: 1,
                  autoplay: 1,
                  disablekb: 1,
                  origin: o.requestHost,
                },
                events: {onStateChange: S, onReady: E},
              })),
              clearInterval(r))
            : o.videoType === 'vimeo' &&
              window.Vimeo &&
              ((e = new window.Vimeo.Player(s, {id: o.videoId, controls: !1})), e.ready().then(L), clearInterval(r)),
            e && document.dispatchEvent(new window.CustomEvent('videoManagement:player', {detail: {...p, player: e}}));
        }, 50);
    },
    f = () =>
      new Promise((s) => {
        (e = t.querySelector('.js-video')),
          e &&
            (document.dispatchEvent(new window.CustomEvent('videoManagement:player', {detail: {...p, player: e}})),
            o.mute || ((e.muted = !1), (e.volume = 1)),
            s());
      }),
    S = (s) => {
      s.data === window.YT.PlayerState.ENDED && e.playVideo();
    },
    E = () => {
      o.mute ? e.mute() : e.unMute(), o.autoplay && d();
    },
    L = () => {
      o.mute || o.autoplay ? e.setVolume(0) : e.setVolume(1), o.autoplay && d();
    };
  t.addEventListener('video:play', d),
    t.addEventListener('video:pause', c),
    o.videoType !== 'mp4'
      ? m()
          .then(w())
          .then(() => {
            v.addEventListener('click', () => {
              a.play ? c() : d();
            });
          })
      : f()
          .then(() => {
            o.autoplay && d();
          })
          .then(() => {
            v.addEventListener('click', () => {
              a.play ? c() : d();
            });
          });
}
const h = document.querySelectorAll('[data-module-init="video"]');
h.forEach((t) => T(t));
